
















import { reactive, defineComponent, computed } from '@vue/composition-api';
import { useStore } from '@/components/composables/useStore';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';
import { ITableHeader } from '@/models/filters/Filters';

interface State {
  value: string;
  searchHeaders: ITableHeader[];
}

interface Props {
  storePath: string;
}

const Component = defineComponent({
  name: 'SearchBar',

  props: {
    storePath: String,
  },

  setup(props: Props) {
    const store: Store<RootState> = useStore();

    const state: State = reactive({
      value: store.getters.searchValue || '',
      searchHeaders: computed(() => store.getters[`${props.storePath}/getSearchHeaders`]),
    });

    function search() {
      store.dispatch(`${props.storePath}/setSearchValue`, state.value);
    }

    function cancelSearch() {
      store.dispatch(`${props.storePath}/setSearchValue`, null);
    }

    return {
      state,
      search,
      cancelSearch,
    };
  },
});

export default Component;
